__turbopack_context__.v({
  "desktopWrapper": "SUEiWq_desktopWrapper",
  "featureIcon": "SUEiWq_featureIcon",
  "featureIcon10": "SUEiWq_featureIcon10",
  "featureIcon11": "SUEiWq_featureIcon11",
  "featureIcon12": "SUEiWq_featureIcon12",
  "featureIcon13": "SUEiWq_featureIcon13",
  "featureIcon14": "SUEiWq_featureIcon14",
  "featureIcon15": "SUEiWq_featureIcon15",
  "featureIcon16": "SUEiWq_featureIcon16",
  "featureIcon17": "SUEiWq_featureIcon17",
  "featureIcon18": "SUEiWq_featureIcon18",
  "featureIcon2": "SUEiWq_featureIcon2",
  "featureIcon3": "SUEiWq_featureIcon3",
  "featureIcon4": "SUEiWq_featureIcon4",
  "featureIcon5": "SUEiWq_featureIcon5",
  "featureIcon6": "SUEiWq_featureIcon6",
  "featureIcon7": "SUEiWq_featureIcon7",
  "featureIcon8": "SUEiWq_featureIcon8",
  "featureIcon9": "SUEiWq_featureIcon9",
  "freeBox": "SUEiWq_freeBox",
  "heading": "SUEiWq_heading",
  "heading10": "SUEiWq_heading10",
  "heading11": "SUEiWq_heading11",
  "heading12": "SUEiWq_heading12",
  "heading13": "SUEiWq_heading13",
  "heading14": "SUEiWq_heading14",
  "heading15": "SUEiWq_heading15",
  "heading16": "SUEiWq_heading16",
  "heading17": "SUEiWq_heading17",
  "heading18": "SUEiWq_heading18",
  "heading2": "SUEiWq_heading2",
  "heading3": "SUEiWq_heading3",
  "heading4": "SUEiWq_heading4",
  "heading5": "SUEiWq_heading5",
  "heading6": "SUEiWq_heading6",
  "heading7": "SUEiWq_heading7",
  "heading8": "SUEiWq_heading8",
  "heading9": "SUEiWq_heading9",
  "img___1DAoD": "SUEiWq_img___1DAoD",
  "img___4L4V": "SUEiWq_img___4L4V",
  "img__aSi1K": "SUEiWq_img__aSi1K",
  "img__eWPu0": "SUEiWq_img__eWPu0",
  "img__fMrt1": "SUEiWq_img__fMrt1",
  "img__h2Sx7": "SUEiWq_img__h2Sx7",
  "img__iDqet": "SUEiWq_img__iDqet",
  "img__jFi64": "SUEiWq_img__jFi64",
  "img__loTpS": "SUEiWq_img__loTpS",
  "img__mtntD": "SUEiWq_img__mtntD",
  "img__nYGjI": "SUEiWq_img__nYGjI",
  "img__oSkog": "SUEiWq_img__oSkog",
  "img__pkUXb": "SUEiWq_img__pkUXb",
  "img__r9XHr": "SUEiWq_img__r9XHr",
  "img__rAvi5": "SUEiWq_img__rAvi5",
  "img__tQnl6": "SUEiWq_img__tQnl6",
  "img__uui20": "SUEiWq_img__uui20",
  "img__vSsMg": "SUEiWq_img__vSsMg",
  "items": "SUEiWq_items",
  "mobileWrapper": "SUEiWq_mobileWrapper",
  "row5": "SUEiWq_row5",
  "row6": "SUEiWq_row6",
  "row7": "SUEiWq_row7",
  "row8": "SUEiWq_row8",
  "row9": "SUEiWq_row9",
  "tabletWrapper": "SUEiWq_tabletWrapper",
  "text10": "SUEiWq_text10",
  "text11": "SUEiWq_text11",
  "text12": "SUEiWq_text12",
  "text13": "SUEiWq_text13",
  "text14": "SUEiWq_text14",
  "text15": "SUEiWq_text15",
  "text16": "SUEiWq_text16",
  "text17": "SUEiWq_text17",
  "text18": "SUEiWq_text18",
  "text19": "SUEiWq_text19",
  "text20": "SUEiWq_text20",
  "text21": "SUEiWq_text21",
  "text22": "SUEiWq_text22",
  "text5": "SUEiWq_text5",
  "text6": "SUEiWq_text6",
  "text7": "SUEiWq_text7",
  "text8": "SUEiWq_text8",
  "text9": "SUEiWq_text9",
  "textWithIcon": "SUEiWq_textWithIcon",
  "textWithIcon10": "SUEiWq_textWithIcon10",
  "textWithIcon11": "SUEiWq_textWithIcon11",
  "textWithIcon12": "SUEiWq_textWithIcon12",
  "textWithIcon13": "SUEiWq_textWithIcon13",
  "textWithIcon14": "SUEiWq_textWithIcon14",
  "textWithIcon15": "SUEiWq_textWithIcon15",
  "textWithIcon16": "SUEiWq_textWithIcon16",
  "textWithIcon17": "SUEiWq_textWithIcon17",
  "textWithIcon18": "SUEiWq_textWithIcon18",
  "textWithIcon2": "SUEiWq_textWithIcon2",
  "textWithIcon3": "SUEiWq_textWithIcon3",
  "textWithIcon4": "SUEiWq_textWithIcon4",
  "textWithIcon5": "SUEiWq_textWithIcon5",
  "textWithIcon6": "SUEiWq_textWithIcon6",
  "textWithIcon7": "SUEiWq_textWithIcon7",
  "textWithIcon8": "SUEiWq_textWithIcon8",
  "textWithIcon9": "SUEiWq_textWithIcon9",
});
